export const GET_RECOMMENDATIONS_QUERY = `
  query getStudentRecommendations(
    $studentId: String,
    $externalStudentId: String,
    $schoolId: String,
    $studentEmail: String,
    $inputDataSources: SkillsStackInputDataSources!,
    $outputResourceTypes: [String]!,
    $subject: String!,
    $numberOfResources: Int,
    $usePlacementQuiz: Boolean
  ) {
    getStudentRecommendations(
      studentId: $studentId,
      externalStudentId: $externalStudentId,
      schoolId: $schoolId,
      studentEmail: $studentEmail,
      inputDataSources: $inputDataSources,
      outputResourceTypes: $outputResourceTypes,
      subject: $subject,
      numberOfResources: $numberOfResources,
      usePlacementQuiz: $usePlacementQuiz
    ) {
      intent
      resource {
        appCourse {
          id
          name
          thirdPartyCourseId
        }
        appLevel {
          id
          name
          thirdPartyLevelId
        }
        appTopic {
          id
          name
          thirdPartyTopicId
        }
        course {
          grade
          gradeName
          name
        }
        masteryPercentage
        name
        order
        standards {
          mappingType
          name
        }
        struggleAssistanceFor {
          resourceName
          resourceUrl
        }
        type
        url
      }
      test {
        app
        courses {
          grade
          gradeName
          name
        }
        name
        url
      }
      type
    }
  }
`;
